import angular from 'angular';
import router from 'angular-ui-router';
import adalAngular from 'modular-adal-angular';

import routes from './core.routes';
import interceptors from './core.interceptors';

import './core.css';

import './fonts/lato-v11-latin-regular.eot';
import './fonts/lato-v11-latin-regular.ttf';
import './fonts/lato-v11-latin-regular.woff';
import './fonts/lato-v11-latin-regular.woff2';
import './fonts/MaterialIcons-Regular.eot';
import './fonts/MaterialIcons-Regular.ttf';
import './fonts/MaterialIcons-Regular.woff';
import './fonts/MaterialIcons-Regular.woff2';

const core = angular.module('core', [
    router,
    adalAngular
]);

core.config(routes);
core.config(interceptors);

export default core.name;



// WEBPACK FOOTER //
// ./src/js/core/core.module.js